import { SET_ERROR } from "../actions/types";

const initialState = {
  errorPane: {
    error: null,
    retryAction: null,
    errorCode: "",
  },
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  switch (action.type) {
    case SET_ERROR:
      var errorPane = Object.assign(state.errorPane, action.payload.errorPane);
      return {
        ...state,
        errorPane: errorPane,
      };
    default:
      return state;
  }
}
